import Vue from 'vue'
import Vuex from 'vuex'
import 'es6-promise/auto'
import { appState } from './appState'
import { queryState } from './queryState'
import { modalState } from './modalState'
import { searchAiState } from './searchAiState'

Vue.use(Vuex)

const notificationState = {
  state: () => ({
    informationTitle: null,
    informationBody: null
  }),
  mutations: {
    setInformationTitle (state, title) {
      state.informationTitle = title
    },
    setInformationBody (state, body) {
      state.informationBody = body
    }
  }
}

const userState = {
  state: () => ({
    test: null
  }),
  getters: () => ({
    // isLoading: state => {
    //   return typeof state.id !== 'undefined'
    // },
  }),
  mutations: {
  }
}

export default new Vuex.Store({
  modules: {
    appState,
    queryState,
    modalState,
    searchAiState,
    notificationState,
    userState
  }
})



//////////////////
// WEBPACK FOOTER
// ./store/index.js
// module id = null
// module chunks = 